<template>
	<div v-if="affiliate" class="flex items-center justify-center bg-utility-gray-100">
		<p class="!m-0 !py-1.5 text-xs flex items-center gap-2 !text-black">
			<span> Affiliate: {{ affiliate.firstName }} {{ affiliate.lastName }} </span>
			<button type="button" aria-label="Leave Affiliate" class="underline" @click="handleAffiliateLeave">Leave</button>
		</p>
	</div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'

const LOCAL_STORAGE_KEY = 'seint_aff'

const props = defineProps({
	isCheckout: {
		type: Boolean,
		default: false,
	},
	addEndpoint: {
		type: String,
		required: true,
	},
	removeEndpoint: {
		type: String,
		required: true,
	},
	currentAffiliate: {
		type: Object,
		default: null,
	},
})

const affiliate = ref(props.currentAffiliate)

onMounted(() => {
	const storedAffiliate = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) ?? null
	if (
		props.currentAffiliate &&
		storedAffiliate &&
		props.currentAffiliate.code !== storedAffiliate.code &&
		!props.isCheckout
	) {
		// new affiliate present - do not store on checkout route
		localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(props.currentAffiliate))
	} else if (!props.currentAffiliate && storedAffiliate) {
		// need to tell backend what's up
		handleAffiliateAdd(storedAffiliate.code)
		affiliate.value = storedAffiliate
	} else if (!props.isCheckout) {
		// store long term if not checkout route
		localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(props.currentAffiliate))
	}

	if (props.isCheckout) {
		// if on checkout route - remove from long term storage (if present)
		localStorage.removeItem(LOCAL_STORAGE_KEY)
	}
})

const handleRemoval = () => {
	localStorage.removeItem(LOCAL_STORAGE_KEY)
	window.location = window.location.pathname // remove aff
}
const handleAffiliateAdd = async (affiliateCode) => {
	try {
		const { data } = await axios.post(props.addEndpoint, { affiliateCode })
		if (!data.success) {
			handleRemoval()
		}
	} catch (_) {
		// long hair don't care
	}
}
const handleAffiliateLeave = async () => {
	try {
		await axios.delete(props.removeEndpoint)
		handleRemoval()
	} catch (_) {
		// long hair don't care
	}
}
</script>
